import angular from 'angular';

import Component from './EditPanelOverlay.component';
import './EditPanelOverlay.scss';

import { downgradedModule } from '../../../ng-app/main';

export default angular
  .module('petroCloud.dashboard.editPanel', [
    downgradedModule
  ])
  .component(Component.name, Component)
  .name;
